/* 申込画面表示区分 */
export default {
    // 数量入力
    ENTER_QUANTITIES : "1",
    // 表示のみ
    ONLY_DISPLAY: "2",
    // 非表示
    HIDE: "9"
}